module.exports = __webpack_public_path__ + "img/hot.3e3da209.svg";